import { useEffect } from "react";

const SITE = "https://genoumgroup.com";
const BRAND = "GENOUM GROUP";

function setMeta(selector, attr, value, content) {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, value);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

/**
 * Per-route title, description and canonical URL.
 *
 * Without this every route serves the same <title>, which search engines read
 * as near-duplicate pages. The brand name stays in every title because the
 * name "Genoum" is otherwise easily confused with Geno / Genuit / Genome.
 *
 * Note: this runs client-side, so crawlers only see it after they execute JS.
 * The homepage values are also hard-coded in public/index.html so the most
 * important page is correct with no JavaScript at all.
 */
export function useSEO({ title, description, path }) {
  useEffect(() => {
    const fullTitle = title ? `${title} | ${BRAND}` : `${BRAND} — Energy, Engineering & Healthcare`;
    document.title = fullTitle;

    if (description) {
      setMeta('meta[name="description"]', "name", "description", description);
      setMeta('meta[property="og:description"]', "property", "og:description", description);
    }
    setMeta('meta[property="og:title"]', "property", "og:title", fullTitle);
    setMeta('meta[name="twitter:title"]', "name", "twitter:title", fullTitle);

    if (path) {
      const url = `${SITE}${path}`;
      setCanonical(url);
      setMeta('meta[property="og:url"]', "property", "og:url", url);
    }
  }, [title, description, path]);
}
